import React, { useState } from 'react';
import '../App.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission (e.g., send data to an API or email)
    alert('Your message has been sent!');
    setFormData({ name: '', email: '', message: '' }); // Clear form
  };

  return (
    <div className="contact-page">
      {/* Header */}
      <header>
        <nav className="navbar">
          <div className="logo">
            <h1>Chaman Hospital</h1>
          </div>
          <ul className="nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/Appointment">Appointment</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/doctors" className="active">Doctors</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <h2>Contact Us</h2>
          <p>If you have any questions or would like to book an appointment, feel free to reach out to us using the form below or find our location on the map.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">Send Message</button>
          </form>

          {/* Hospital Location with Pin */}
          <div className="map">
            <h3>Our Location</h3>
            <p>Find us at Chaman Hospital, Bahadurgarh, Patiala.</p>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3147.879084400895!2d75.570648!3d30.3712104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a466da7f3f5b7%3A0x400cd4c123a1be20!2sChaman%20Hospital%2C%20Bahadurgarh%2C%20Patiala!5e0!3m2!1sen!2sin!4v1618270423459!5m2!1sen!2sin"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Working Hours Section */}
          <div className="working-hours">
            <h3>Working Hours</h3>
            <ul>
              <li><strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM</li>
              <li><strong>Saturday:</strong> 9:00 AM - 2:00 PM</li>
              <li><strong>Sunday:</strong> Closed</li>
            </ul>
          </div>

          {/* Contact Information Section */}
          <div className="contact-info">
            <h3>Contact Information</h3>
            <ul>
              <li><strong>Phone:</strong> +91 123 456 7890</li>
              <li><strong>Email:</strong> info@chamanhospital.com</li>
              <li><strong>Address:</strong> Bahadurgarh, Patiala, Punjab</li>
            </ul>
          </div>

          {/* Frequently Asked Questions */}
          <div className="faq">
            <h3>Frequently Asked Questions</h3>
            <div className="faq-item">
              <h4>What services do you offer?</h4>
              <p>We offer a wide range of medical services, including general medicine, surgery, pediatrics, cardiology, gynecology, and physiotherapy.</p>
            </div>
            <div className="faq-item">
              <h4>How can I book an appointment?</h4>
              <p>You can book an appointment by calling our helpline at +91 123 456 7890 or by filling out the contact form above.</p>
            </div>
            <div className="faq-item">
              <h4>Do you accept insurance?</h4>
              <p>Yes, we accept various insurance plans. Please contact our office for more information about coverage.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
